export default "__VITE_ASSET__Ct1VWNTe__"